import React, { useContext, useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { IElement } from '@routes/private/Editor/types';
import Layer from './Layer'
import LayerElement from '@components/LayerElement';
import LayerGroup from '@components/LayerGroup';
import { isGroupOpen } from '@utils/layers';
import { getParentCategoryColor } from '@utils/selectDescribe';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { ColName } from '@routes/private/Templates/components/ListTemplate/components/ItemTemplate/styles';

const Layers:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const data = context.data;
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [layer, setLayer] = useState(-1);

  const layerGroup = (groupElement: any, level: number) => {
    return  <LayerGroup id={groupElement.id} HideUnhide={(elementId) => context.onCommandChange("hideUnhide",undefined,[elementId], undefined, undefined, undefined, undefined, 'LAYERS_PICKER')}  title={groupElement.name} level={level} isOpen={isGroupOpen(groupElement.id,context.editorStatus.groupsStatus)}  onClick={() => { context.onGroupOpenStatusChange(groupElement.id)}}  hidden={groupElement.attributes.hidden}
              onEdit={(name:string)=>handleEditName(groupElement,name)}
            >
              {groupElement.children && layerElements(groupElement.children, level + 1)}
            </LayerGroup>
  }


  const handleEditName=(element:IElement, name:string)=>{
      context.onCommandChange("editName", name,[element.id]);    
  }


  const layerElements = (elements: any, level: number) => {
    let elementsrev =  [...elements].reverse();    
    return elementsrev.map((element:any) => {      
      let layerItem = null;
      if (['Text', 'Image', 'Shape'].indexOf(element.type)!== -1)
        layerItem = <LayerElement 
                  pickerType={"LAYERS"} 
                  id={element.id} 
                    
                  HideUnhide={(elementId) => context.onCommandChange("hideUnhide",undefined,[elementId], undefined, undefined, undefined, undefined, 'LAYERS_PICKER')} 
                    
                  level={level} 
                  selected={context.editorStatus.selectedElementsId.includes(element.id)} 
                    
                  isOver={context.editorStatus.overElementId===element.id} 
                    
                  onClick={()=>context.onSelectedElementsIdChange(element.id)}  
                    
                  onOver={(isOver: boolean) => context.onOverElementIdChange(element.id,isOver)} 
                    
                  title={element.name} type={element.type} 
                  hidden={element.attributes.hidden} 
                    
                  parentColor={context.editorStatus.showSelectDescribe && context.editorStatus.showDescribedLayerColor?getParentCategoryColor(element.id,dsConfig?.selectDescribeConfig.categories,context.selectDescribe?.templateFields,context.selectDescribe?.taggedFields):undefined}
                    onEdit={(name:string)=>{handleEditName(element,name);}}
                    selectDescribe={context.editorStatus.showSelectDescribe}
                    
                  locked={element.attributes.locked}
                  lockUnlock={(elementId: string, value: boolean) =>  context.onCommandChange("lockUnlockElement",value,[elementId])}
                  />;
      if (['Group'].indexOf(element.type)!== -1)
        layerItem = layerGroup(element, level + 1)
      return  <> 
                {layerItem}
              </>;
    });
  }

  // ASUMPTION - Should there be only 1 artboards per psd and artboard can not contain another artboard
  const artboards =  data[0]?.children ?  [...data[0].children.filter(e => e.type === "Artboard")].reverse() : [];
  return (
    <S.Root bgColor={!context.editorStatus.showSelectDescribe?"#ffffff":undefined}>
      <S.Layers>
        { artboards.length > 0 &&
            artboards.map((artboard: IElement, index: number) => 
            <Layer
              index={index}
              title={artboard.name}
              active={layer==index}
              onClick={()=> {                
                if (index!==layer) setLayer(index);
                else setLayer(-1);
              }}>               
                {                  
                  artboard.children &&
                  layerElements(artboard.children, 0)
                }
            </Layer>
            )
        }
      </S.Layers>
    </S.Root>
  );
}

export default Layers;